import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SimpleFrame from '../../../Components/UI/SimpleFrame/SimpleFrame';
import useHttp from '../../../hooks/http';
import { showError } from '../../../store';
import './ListF.scss';

const ListF = () => {
  const [Groups, setGroups] = useState();
  const { isLoading, data, error, sendRequest, clear } = useHttp();
  const { url, title, items } = { url: 'get/groups', title: 'لیست گروه ها', items: ['name'] };

  const token = useSelector((state) => state.auth.Token);
  const dispatch = useDispatch();
  const setMessage = useCallback(
    (mess) => {
      dispatch(showError(mess));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!isLoading && !error && data) {
      console.log(data);

      setGroups(data);
      setMessage({
        message: data.message,
        type: data.status,
      });

      clear();
    }
  }, [error, isLoading, data, clear, setMessage]);

  useEffect(() => {
    sendRequest(url, 'GET', null, { Authorization: `Bearer ${token}` });
  }, [sendRequest, token, url]);

  return (
    <SimpleFrame>
      <h2>{title}</h2>
      {Groups && (
        <ul className='ListF'>
          {Groups.map((e) => (
            <li key={e.id}>
              {items.map((item) => (
                <span key={item}>{e[item]}</span>
              ))}
            </li>
          ))}
        </ul>
      )}
    </SimpleFrame>
  );
};

export default ListF;
